import axios from "axios"

export const axiosInstance = axios.create({
    baseURL : "https://asynccollab-api.onrender.com/api/",
    withCredentials : "true"
})